import { c as _c } from "react/compiler-runtime";
import { Stack, Text, Icon, SystemStyleObject } from "@chakra-ui/react";
type KeyElemProps = {
  name: string;
  color: SystemStyleObject["color"];
  icon: React.ReactNode;
  isMobile?: boolean;
};
export const KeyElem = t0 => {
  const $ = _c(10);
  const {
    name,
    color,
    icon,
    isMobile
  } = t0;
  const t1 = isMobile ? "sm" : "md";
  let t2;
  if ($[0] !== color || $[1] !== icon || $[2] !== t1) {
    t2 = <Icon size={t1} color={color}>{icon}</Icon>;
    $[0] = color;
    $[1] = icon;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isMobile ? "textSmall" : "textMedium";
  let t4;
  if ($[4] !== name || $[5] !== t3) {
    t4 = <Text textStyle={t3} layerStyle="headerAlt" fontWeight="bold" whiteSpace="nowrap">{name}</Text>;
    $[4] = name;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <Stack direction="row" alignItems="center">{t2}{t4}</Stack>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};